<ng-template #modalSequenceCall let-modal>
  <div class="modal-header">
    <h4 class="modal-title">
      <i class="fa fa-phone"></i>
      Ative as chamadas de voz na sua campanha!
    </h4>
    <button type="button" class="sf-btn sf-btn--ghost sf-btn--icon sf-btn--sm" aria-label="Fechar" (click)="modalRef.dismiss()">
      <i class="fa fa-times"></i>
    </button>
  </div>

  <div class="modal-body">
    <p class="lead-text">Dispare ligações automáticas com áudios personalizados direto da sua automação,
      qualifique leads por DTMF e potencialize seus resultados.</p>

    <ul class="benefits-from-call4u">
      <li><i class="fa fa-check-circle"></i><span>Configure disparos de chamadas de voz na sua campanha</span></li>
      <li><i class="fa fa-check-circle"></i><span>Qualifique e se aproxime ainda mais do seu público</span></li>
      <li><i class="fa fa-check-circle"></i><span>Converta ainda mais com campanhas híbridas</span></li>
      <li><i class="fa fa-check-circle"></i><span>Ative hoje e ganhe <b>200 ligações grátis</b> para testar a ferramenta!</span></li>
    </ul>

    <p class="terms-from-call4u">Ao ativar você concorda com a ativação do serviço de chamadas de voz
      e o envio dos contatos para disparo das ligações.</p>
  </div>

  <div class="modal-footer">
    <button type="button" class="sf-btn sf-btn--ghost push" (click)="modalRef.dismiss()">
      Fechar
    </button>
    <button type="button" class="sf-btn sf-btn--primary" (click)="next()" [disabled]="activating" data-testid="btn-activate-call4u">
      <i class="fa fa-phone"></i> {{ activating ? 'Ativando...' : 'Ativar agora' }}
    </button>
  </div>
</ng-template>
